import * as React from "react";
import { useUsers } from "./hooks/useUsers";
import UsersTable from "./components/UsersTable";
import { IUserSearch } from "src/share/types/user";
import { RoutesModules } from "src/modules/Routing/types";
import SidebarContainer from "src/modules/Routing/Sidebar/SidebarContainer";
import './users.css';

const initialSearch: IUserSearch = {
  sort: [],
  page: 0,
  size: 10,
  queryString: "",
};

const Users = (): React.ReactElement => {
  const [search, setSearch] = React.useState(initialSearch);
  const { users, total, isLoading } = useUsers(search);
  function handleSort(column, sortDirection): void {
    setSearch(prevSearch => ({ ...prevSearch, sort: [{ [column.selector]: sortDirection }] }));
  }
  return (
    <div className="application-users">
      <div className="application-users-container white-background">
        <h3 className="title float-left">
          Users
            </h3>
        <UsersTable
          users={users}
          loading={isLoading}
          total={total}
          onSizeChanged={(size, page): void => setSearch(prevSearch => ({ ...prevSearch, size, page: page - 1 }))}
          onPageChanged={(page): void => setSearch(prevSearch => ({ ...prevSearch, page: page - 1 }))}
          onTextChanged={(text): void => setSearch(prevSearch => ({ ...prevSearch, queryString: text }))}
          onSort={handleSort}
        />
      </div>
    </div>
  );
}

export default SidebarContainer(RoutesModules.ADMIN)(Users);



// WEBPACK FOOTER //
// ./src/modules/UserSettings/Users/Users.tsx